import React, { useState, useEffect } from 'react'
//import { useParams } from 'react-router-dom'
import { useSelector } from 'react-redux'

import { Panel, Table, Form, Message } from 'rsuite'
import { useForm } from 'react-hook-form'
import { v4 as uuidv4 } from 'uuid'
import { saveBudgetInstallmentPlan } from '../../../redux/actions/paymentSave'
import { startLoading, doneLoading } from '../../../utils/loading'
// import ConfirmWidget from '../../confirm/ConfirmWidget'
import EditNumberCell from '../../../components/cell/EditNumberCell'
import EditCascaderCell from '../../../components/cell/EditCascaderCell'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import EditButton from '../../../components/buttons/editButton/EditButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import './styles.less'
import { getActionPlanLabelByPlanCode } from '../../../utils/dataUtil'
import { budgetFormat } from '../../../utils/formatterUtil'

const { Column, HeaderCell, Cell } = Table

export default function BudgetInstallmentPlan({
  header,
  isEditable,
  isEdit,
  setIsEdit,
  masterBudgetPlanLabel,
  masterBudgetPlanItems,
  subBudgetPlanLabel,
  subBudgetPlanItems,
  periodExpenses,
  installment,
  setInstallment,
  projectVersionId,
  budgetPlan,
  onComplete = () => {},
  onMultiSave = () => {},
  isMulti,
  isEditWithdrawBudget,
  onSaveInstallmentPlan,
  errorMessage: _errorMessage,
}) {
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const { register, handleSubmit, errors, control, watch, setValue, getValues } = useForm()
  // const [oldData, setOldData] = useState([])
  const [tableData, setTableData] = useState([])
  const [errorMessage, setErrorMessage] = useState()
  const [isLoading, setIsLoading] = useState(false)

  const watchMasterBudgetPlanValue = watch('masterBudgetPlanValue', [])
  // console.log('BudgetInstallmentPlan projectVersionId', projectVersionId)

  useEffect(() => {
    if (_errorMessage) {
      setErrorMessage(_errorMessage)
    }
  }, [_errorMessage])

  useEffect(() => {
    if (!periodExpenses && periodExpenses?.length !== 0) {
      setTableData([])
      return
    }
    convertData(installment, periodExpenses)
  }, [installment, periodExpenses])

  const convertData = (installment, periodExpenses) => {
    let existInstallment = installment || []
    const numberOfExistInstallment = existInstallment?.length || 0
    const numberOfPeriodExpenses = periodExpenses?.length || 0
    let newData = []
    if (numberOfPeriodExpenses >= numberOfExistInstallment) {
      const _data = [...new Array(numberOfPeriodExpenses - numberOfExistInstallment)].map(
        (_, index) => {
          return {
            numInstallment: numberOfExistInstallment + index + 1,
            masterBudgetPlanText: '',
            masterBudgetPlanValue: budgetPlan?.masterBudgetPlan?.value || '',
            masterBudgetValue: 0,
            subBudgetPlanText: '',
            subBudgetPlanValue: budgetPlan?.subBudgetPlan?.value || '',
            subBudgetValue: 0,
          }
        }
      )
      newData = [...existInstallment, ..._data]
    } else {
      newData = existInstallment.slice(0, numberOfPeriodExpenses)
    }
    setTableData(newData)
  }

  // useEffect(() => {
  //   setOldData(installment)
  // }, [installment])

  useEffect(() => {
    if (tableData) {
      const haveSubPlan = !!budgetPlan?.subBudgetPlan?.value
      tableData.forEach((_, index) => {
        const periodExpensesValue = periodExpenses?.[index]?.cost || 0
        const currentValue =
          (getValues(`masterBudgetValue.${index}`) || 0) +
          (getValues(`subBudgetValue.${index}`) || 0) +
          (getValues(`subSubBudgetValue.${index}`) || 0)
        if (currentValue !== periodExpensesValue) {
          setValue(
            `masterBudgetValue.${index}`,
            haveSubPlan ? periodExpensesValue / 2 : periodExpensesValue
          )
          setValue(`subBudgetValue.${index}`, haveSubPlan ? periodExpensesValue / 2 : 0)
          setValue(`subSubBudgetValue.${index}`, 0)
        }
      })
    }
  }, [tableData, isEdit])

  useEffect(() => {
    if (budgetPlan) {
      tableData.forEach((_, index) => {
        setValue(`masterBudgetPlanValue.${index}`, budgetPlan?.masterBudgetPlan?.value)
        setValue(`subBudgetPlanValue.${index}`, budgetPlan?.subBudgetPlan?.value)
      })
    }
  }, [budgetPlan])

  const handleSaveBudgetInstallmentPlan = async (request) => {
    startLoading()
    setIsLoading(true)
    setErrorMessage(null)
    try {
      const _schema = await saveBudgetInstallmentPlan(request, projectVersionId || projectId)

      setIsEdit(false)
      if (_schema?.model?.forms?.budgetInstallmentPlan?.installment) {
        setInstallment(_schema.model.forms.budgetInstallmentPlan.installment)
      }
      convertData(_schema?.model?.forms?.budgetInstallmentPlan?.installment, periodExpenses)
      onComplete()
    } catch (e) {
      setErrorMessage('เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ')
    }
    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('data', data)
    if (!data) {
      return
    }

    setErrorMessage()
    let dataByInstallment = []
    let totalBudget = 0
    for (const [index, item] of periodExpenses.entries()) {
      if (!installment[index]?.disabled) {
        //subSubBudgetPlanValue
        //subSubBudgetValue
        const masterBudgetValue = data.masterBudgetValue?.[index] || 0
        const subBudgetValue = data.subBudgetValue?.[index] || 0
        const subSubBudgetValue = data.subSubBudgetValue?.[index] || 0
        if (masterBudgetValue + subBudgetValue + subSubBudgetValue !== item.cost) {
          setErrorMessage(`กรุณากรอกงบประมาณของงวดที่ ${index + 1} ให้ถูกต้อง`)
          return
        }

        totalBudget = totalBudget + masterBudgetValue + subBudgetValue + subSubBudgetValue

        const masterActionPlanLabel = getActionPlanLabelByPlanCode(
          masterBudgetPlanItems,
          data.masterBudgetPlanValue?.[index]
        )
        const subActionPlanLabel = getActionPlanLabelByPlanCode(
          subBudgetPlanItems,
          data.subBudgetPlanValue?.[index]
        )
        const subSubActionPlanLabel = getActionPlanLabelByPlanCode(
          subBudgetPlanItems,
          data.subSubBudgetPlanValue?.[index]
        )

        dataByInstallment.push({
          projectVersionId: projectVersionId || projectId,
          numInstallment: index + 1,
          masterBudgetPlanValue: data.masterBudgetPlanValue?.[index] || null,
          masterBudgetValue: masterBudgetValue || 0,
          masterBudgetPlanText: data.masterBudgetPlanValue?.[index] + ' : ' + masterActionPlanLabel,

          subBudgetPlanValue: data.subBudgetPlanValue?.[index] || null,
          subBudgetValue: data.subBudgetPlanValue?.[index] ? subBudgetValue || 0 : null,
          subBudgetPlanText: data.subBudgetPlanValue?.[index]
            ? data.subBudgetPlanValue?.[index] + ' : ' + subActionPlanLabel
            : null,

          subSubBudgetPlanValue: data.subSubBudgetPlanValue?.[index] || null,
          subSubBudgetValue: data.subSubBudgetPlanValue?.[index] ? subSubBudgetValue || 0 : null,
          subSubBudgetPlanText: data.subSubBudgetPlanValue?.[index]
            ? data.subSubBudgetPlanValue?.[index] + ' : ' + subSubActionPlanLabel
            : null,
        })
      } else {
        totalBudget = totalBudget + installment[index].masterBudgetValue
        dataByInstallment.push(installment[index])
      }
    }

    const requestBudgetSummary =
      (budgetPlan?.masterBudgetValue?.value || 0) + (budgetPlan?.subBudgetValue?.value || 0)

    if (parseFloat(totalBudget.toFixed(2)) !== requestBudgetSummary) {
      let difference = Math.abs(totalBudget - requestBudgetSummary)
      let differenceText = ''

      if (parseFloat(totalBudget.toFixed(2)) > requestBudgetSummary) {
        differenceText = 'เกินมา'
      } else {
        differenceText = 'ขาดอีก'
      }
      setErrorMessage(
        `กรุณากรอกงบประมาณให้ตรงกับจำนวนที่ขออนุมัติ (${differenceText} ${budgetFormat(
          difference
        )} บาท)`
      )
      return
    }

    if (isMulti) {
      onMultiSave(dataByInstallment)
    } else if (isEditWithdrawBudget) {
      onSaveInstallmentPlan(dataByInstallment)
      setIsEdit(false)
      setInstallment(dataByInstallment)
    } else {
      handleSaveBudgetInstallmentPlan(dataByInstallment)
    }
  }

  const onCancel = () => {
    setIsEdit(false)
    setErrorMessage()
  }

  return (
    <div className="budget-installment-plan">
      <Panel header={header} bordered collapsible defaultExpanded>
        {tableData && (
          <Form className="form-table">
            <Table rowKey="id" autoHeight rowHeight={64} wordWrap data={tableData}>
              <Column width={83}>
                <HeaderCell>งวดเงิน</HeaderCell>
                <Cell>
                  {(rowData) => {
                    return <span>{`งวดที่ ${rowData.numInstallment}`}</span>
                  }}
                </Cell>
              </Column>
              <Column flexGrow={1}>
                <HeaderCell>{masterBudgetPlanLabel}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!isEdit || rowData.disabled) {
                      return <span>{rowData.masterBudgetPlanText}</span>
                    }
                    return (
                      <EditCascaderCell
                        id={`masterBudgetPlanValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="masterBudgetPlanValue"
                        items={masterBudgetPlanItems}
                        placeholder={masterBudgetPlanLabel}
                        error={errors?.masterBudgetPlanValue?.[rowData.numInstallment - 1]}
                        rules={{ required: 'กรุณากรอกแผนหลัก' }}
                        isEdit={isEdit}
                        register={register}
                        control={control}
                        onChange={() =>
                          setValue(`subBudgetPlanValue.${rowData.numInstallment - 1}`, null)
                        }
                      />
                    )
                  }}
                </Cell>
              </Column>
              <Column width={170} align="right">
                <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (!isEdit || rowData.disabled) {
                      return <span>{budgetFormat(rowData.masterBudgetValue || 0)} </span>
                    }
                    return (
                      <EditNumberCell
                        id={`masterBudgetValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="masterBudgetValue"
                        isEdit={isEdit}
                        register={register}
                        control={control}
                        errors={errors}
                      />
                    )
                  }}
                </Cell>
              </Column>
              <Column flexGrow={1}>
                <HeaderCell>{subBudgetPlanLabel}</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (
                      !budgetPlan?.subBudgetPlan?.value &&
                      (isEditWithdrawBudget ? false : true)
                    ) {
                      return null
                    } else if (!isEdit || rowData.disabled) {
                      return <span>{rowData.subBudgetPlanText}</span>
                    }
                    return (
                      <EditCascaderCell
                        id={`subBudgetPlanValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="subBudgetPlanValue"
                        items={subBudgetPlanItems}
                        disabledItemValues={[
                          watchMasterBudgetPlanValue?.[rowData.numInstallment - 1],
                        ]}
                        placeholder={subBudgetPlanLabel}
                        isEdit={isEdit}
                        register={register}
                        control={control}
                      />
                    )
                  }}
                </Cell>
              </Column>
              <Column width={170} align="right">
                <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (
                      !budgetPlan?.subBudgetPlan?.value &&
                      (isEditWithdrawBudget ? false : true)
                    ) {
                      return null
                    } else if (!isEdit || rowData.disabled) {
                      return <span>{budgetFormat(rowData.subBudgetValue || 0)}</span>
                    }
                    return (
                      <EditNumberCell
                        id={`subBudgetValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="subBudgetValue"
                        isEdit={isEdit}
                        register={register}
                        control={control}
                        errors={errors}
                      />
                    )
                  }}
                </Cell>
              </Column>
              {/* <Column flexGrow={1}>
                <HeaderCell>{subBudgetPlanLabel}2</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (
                      !budgetPlan?.subSubBudgetPlan?.value &&
                      (isEditWithdrawBudget ? false : true)
                    ) {
                      return null
                    } else if (!isEdit || rowData.disabled) {
                      return <span>{rowData.subSubBudgetPlanText}</span>
                    }
                    return (
                      <EditCascaderCell
                        id={`subSubBudgetPlanValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="subSubBudgetPlanValue"
                        items={subBudgetPlanItems}
                        disabledItemValues={[
                          watchMasterBudgetPlanValue?.[rowData.numInstallment - 1],
                        ]}
                        placeholder={subBudgetPlanLabel}
                        isEdit={isEdit}
                        register={register}
                        control={control}
                      />
                    )
                  }}
                </Cell>
              </Column>
              <Column width={120} align="right">
                <HeaderCell>จำนวนเงิน (บาท)</HeaderCell>
                <Cell>
                  {(rowData) => {
                    if (
                      !budgetPlan?.subSubBudgetPlan?.value &&
                      (isEditWithdrawBudget ? false : true)
                    ) {
                      return null
                    } else if (!isEdit || rowData.disabled) {
                      return <span>{rowData.subSubBudgetValue?.toLocaleString()}</span>
                    }
                    return (
                      <EditNumberCell
                        id={`subSubBudgetValue.${rowData.numInstallment - 1}`}
                        rowData={rowData}
                        dataKey="subSubBudgetValue"
                        isEdit={isEdit}
                        register={register}
                        control={control}
                        errors={errors}
                      />
                    )
                  }}
                </Cell>
              </Column> */}
            </Table>
          </Form>
        )}
        {isEditable && (
          <>
            <br />
            {isEdit ? (
              <div>
                {!!errorMessage && (
                  <div style={{ marginBottom: 10 }}>
                    <Message showIcon type="error" description={errorMessage} />
                  </div>
                )}
                <SaveButton
                  onClick={handleSubmit(onSubmit)}
                  disabled={isLoading || !periodExpenses?.length}
                >
                  {isMulti && 'บันทึกการแก้ไขไปยังทุกโครงการ'}
                </SaveButton>
                <CancelButton
                  onClick={onCancel}
                  disabled={isLoading || !periodExpenses?.length}
                ></CancelButton>
              </div>
            ) : (
              <EditButton
                onClick={() => {
                  setIsEdit(true)
                }}
                disabled={!periodExpenses?.length}
              >
                แก้ไขแผน
              </EditButton>
            )}
          </>
        )}
      </Panel>
      {/* <ConfirmWidget
        title={`ยืนยันการบันทึกแผน`}
        show={isShowConfirmModal}
        detail={`กรุณายืนยันการบันทึกแผน`}
        onCancle={() => setIsShowConfirmModal(false)}
        onConfirm={handleOnConfirmModal}
      /> */}
    </div>
  )
}
